import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import ReactTooltip from 'react-tooltip'

import wrapper from '../../utilities/Wrapper'
import { urlFor, client } from '../../utilities/index'
import motionWrapper from '../../utilities/MotionWrapper'
import './Skills.scss'

const Skills = () => {
  const [experiences, setExperiences] = useState([])
  const [skills, setSkills] = useState([])
  const [tooltip, showTooltip] = useState(true)

  useEffect(() => {
    const expQuery = '*[_type == "experiences"]'
    const skillQuery = '*[_type == "skills"]'
    client.fetch(expQuery).then(data => {
      console.log(data.map((a,b)=> +a.year).sort((a,b)=> a - b))
      setExperiences(data.sort((a,b)=> +a.year - +b.year).reverse())
    })
    client.fetch(skillQuery).then(data => {
      setSkills(data)
    })
  }, [])

  return (
    <>
      <h2 className='head-text dark:text-white'>Skills & Experiences</h2>

      <div className='app__skills-container'>
        <motion.div className='app__skills-list'>
          {skills.map(skill => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className='app__skills-item app__flex'
              key={skill.name}
            >
              <div
                className='app__flex dark:bg-slate-800'
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className='p-text'>{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className='app__skills-exp'>
          {experiences.map(experience => (
            <motion.div className='app__skills-exp-item' key={experience.year}>
              <div className='app__skills-exp-year'>
                <p className='bold-text dark:text-white'>{experience.year}</p>
              </div>
              <motion.div className='app__skills-exp-works'>
                {experience.works.map(work => (
                  <React.Fragment key={work.name}>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className='app__skills-exp-work'
                      data-tip={work.desc}
                      data-for={work.name}
                      onMouseEnter={() => showTooltip(true)}
                      onMouseLeave={() => {
                        showTooltip(false)
                        setTimeout(() => showTooltip(true), 50)
                      }}
                    >
                      <h4 className='bold-text dark:text-slate-400'>
                        {work.name}
                      </h4>
                      <p className='text-gray dark:text-white p-text '>
                        {work.company}
                      </p>
                    </motion.div>
                    {tooltip && (
                      <ReactTooltip
                        id={work.name}
                        effect='solid'
                        arrowColor='#fff'
                        place='left'
                        scrollHide
                        className='skills-tooltip'
                      />
                    )}
                  </React.Fragment>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  )
}

export default wrapper(
  motionWrapper(Skills, 'app__skills'),
  'skills',
  'app__whitebg dark:bg-black'
)
